import {AbstractRepository} from "../repository";

interface AppSettings {
  api_cache_ttl: number
  brand_logo: string
  brand_name: string
  mail_reply_to: string
  medewerkers_call_center_enabled: number
  medewerkers_call_center_nummer: string
  taken_opschonen_agenda_change_na_dagen: number
  taken_opschonen_agenda_remove_na_dagen: number
  taken_opschonen_call_na_dagen: number
  taken_opschonen_document_signed_na_dagen: number
  taken_opschonen_sign_document_na_dagen: number
  should_show_chat_purge_notifications: boolean
  should_purge_chats: boolean
}

export type SettingMap = AppSettings & {[setting: string]: string|number|boolean}

export default class SettingsRepository extends AbstractRepository {
    /**
     * List settings for a Jane instance
     */
    public all(): Promise<SettingMap> {
        return this.request<{data: SettingMap}>('GET', 'settings')
            .then(json => json.data)
    }

    /**
     * Update all settings for a Jane instance
     */
    public update(settings: Partial<SettingMap>): Promise<SettingMap> {
        return this.request<{data: SettingMap}>('PATCH', 'settings', settings)
            .then(json => json.data)
    }
}
